import { style } from 'typestyle';
import { Night80 } from '../../../styles/colors';
const windowBackdropStyle = style({
    background: Night80,
});
export default windowBackdropStyle;
//# sourceMappingURL=WindowBackdrop.js.map